import { FileText } from 'lucide-react';

import { formatarData } from '@/nucleo/formato/datas';
import { formatarDinheiro } from '@/nucleo/dinheiro';
import { EmptyState } from '@/ui/EmptyState';
import { Spinner } from '@/ui/Spinner';
import { StatusBadge, type StatusVariant } from '@/ui/StatusBadge';
import { Card, CardContent } from '@/ui/base/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/ui/base/table';

import { useTermosDoCredenciado, type TermoDoCredenciado } from './detalheDados';

interface AbaTermosProps {
  credenciadoId: string;
}

const SELO_DO_STATUS_DO_TERMO: Record<TermoDoCredenciado['status'], StatusVariant> = {
  ATIVO: 'ativo',
  ENCERRADO: 'extinto',
  RESCINDIDO: 'rescindido',
  ASSINATURA_PENDENTE: 'assinatura_pendente',
};

/**
 * Aba "Termos". SEM CLIQUE NA LINHA DE PROPOSITO: o protótipo levava a
 * `/termos/:id`, rota que nao existe neste repositorio — linkar cairia em
 * "pagina nao encontrada", exatamente o que a proibicao de rota orfa evita
 * (docs/ALVOS.md, "Cinco telas de detalhe dos modulos de cadastro").
 */
export function AbaTermos({ credenciadoId }: AbaTermosProps) {
  const { data: termos, isLoading } = useTermosDoCredenciado(credenciadoId);

  return (
    <Card>
      <CardContent className="p-6">
        {isLoading ? (
          <Spinner size="sm" />
        ) : !termos || termos.length === 0 ? (
          <EmptyState
            icon={FileText}
            title="Nenhum termo vinculado"
            description="Os termos de adesão serão exibidos aqui quando cadastrados."
          />
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Nº SEI</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Início</TableHead>
                <TableHead>Fim</TableHead>
                <TableHead className="text-right">Valor do contrato</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {termos.map((termo) => (
                <TableRow key={termo.id}>
                  <TableCell className="font-mono">{termo.numero_sei || '—'}</TableCell>
                  <TableCell>
                    <StatusBadge
                      status={SELO_DO_STATUS_DO_TERMO[termo.status]}
                      label={termo.status}
                    />
                  </TableCell>
                  <TableCell>{formatarData(termo.data_inicio)}</TableCell>
                  <TableCell>{formatarData(termo.data_fim)}</TableCell>
                  <TableCell className="text-right font-mono">
                    {formatarDinheiro(termo.valor_mensal)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
